import { Component, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { CheckListDTO, ImageDTO, SafeVideoDTO, TemplateDTO, UserProcedureDataDTO, VideoDTO, DeleteImageDTO, DeleteCheckListDTO, DeleteVideoDTO } from '../Models/Procedure.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { SrubUpService } from '../Services/ScrubUp.service';
import { UserProcedureComponent } from '../user-procedure/user-procedure.component';
import { ProcedureComponent } from '../procedure/procedure.component';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { element } from 'protractor';
import { Alert, AlertPromise } from 'selenium-webdriver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
declare var swal: any;
interface FileReaderEventTarget extends EventTarget {
  result: string;
}
interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}


@Component({
  selector: 'app-procedure-user-comp',
  templateUrl: './procedure-user-comp.component.html',
  styleUrls: ['./procedure-user-comp.component.scss']
})
export class ProcedureUserCompComponent implements OnInit {
  equipmentCategories=['123','12432'];
  patientPosPressList:any=[];
  imageUrl: any = [];
  checklistForm: FormGroup;
  submitted = false;
  public baseurl: string = environment.base_url;
  UserProcedureCheckListID: any;
  imagedisplay = "none";
  public image: any;
  public imageAdd: any = [];
  loginUserId: number;
  display = "none";
  editdisplay = "none";
  videodisplay = "none";
  isImpersonateMode: boolean;
  selectedProcedureName: string;
  editvisi: number;
  showEditingDiv: number;
  iValue: number;
  imageUploadApiUrlLength: number;
  public loading = false;
  checkListIndex: number;
  index: boolean;
  index1: number;
  edit: boolean;
  category: number;
  imagePath: string;
  procedureId: string;
  specialityId: number;
  addImageInvisible: number;
  selectedProcedureId: number;
  editmode = false;
  addChecklistItem: number;
  addVideoVisible: number;
  videoList: Array<VideoDTO>;
  safeVideoList: Array<SafeVideoDTO>;
  imageList: Array<ImageDTO>;
  imageList1: any = [];
  checkList: Array<CheckListDTO>;
  videoUrl: string;
  videoName: string;
  imageName: string;
  imageName1: any;
  description: string;
  uploadUrl: string;
  myHeaders: { [name: string]: any };
  tempUrl: Array<string>;
  selectedSpecialityImage: string;
  imageToShow: string;
  
  values = [];
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private _sanitizer: DomSanitizer, private cookieService: CookieService, private appUserDetails: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.selectedSpecialityImage = './assets/img/card_icons/' + Globals.SpecialityName + '.png';
    //this.selectedProcedureName = Globals.SelectedProcedureName;

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.category = Globals.CategoryId;
    this.procedureId = Globals.PId;
    this.specialityId = Globals.SpecialityId;

    this.imageList = new Array<ImageDTO>();
    this.checkList = new Array<CheckListDTO>();
    this.videoList = new Array<VideoDTO>();
    this.safeVideoList = new Array<SafeVideoDTO>();
    this.checkListIndex = 1;
    this.addImageInvisible = 0;
    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Procedure"
    };
    this.tempUrl = new Array<string>();
  }

  removevalue(UserProcedureCheckListImageID,i) {
    let SurgeonId = this.cookieService.get("surgonId");
    if(UserProcedureCheckListImageID)
    {
      let deleteImage = {
        "SurgeonId":SurgeonId,
        "SurgeonProcedureCheckListID": 0,
        "SurgeonProcedureCheckListImageID": UserProcedureCheckListImageID
      }

      this.scrubUpService.DeleteUserImages(this.token, deleteImage).subscribe(x => {
        if (x.Status == true) {
          this.values.splice(i, 1);
          this.imageUrl.splice(i,1);
          this.imageAdd.splice(i,1);
        }
        else if (x.Status == false) {
        }
      });
    }
    else{
      this.values.splice(i, 1);
      // this.imageAdd.splice(i, 1);
       this.imageUrl.splice(i,1);
       //console.log(this.imageAdd);
       this.imageAdd.splice(i,1);
    }

  }

  addvalue() {
    this.values.push({});
  }
  ShowImage(index) {
    this.imageToShow = this.imageList[index].ImageBase64;
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.imageList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });

    });
  }
  checkExtension(file: any) {
    let mimeType = ['image/png', 'image/jpeg', 'image/jpg'];
    return mimeType.indexOf(file.type);
  }
  OnUploadFinished($event: any, imagename: any, i: any) {
  //  console.log(this.imageAdd);
    let uploadStatus: string;
    //let imagevalidation = this.translateService.instant('imageValidation');
    const files = $event.target.files || $event.srcElement.files;
    const file = files[0];
    const type = this.checkExtension(file);
    if (file && type != -1) {
      this.image = file;
      // console.log( this.image);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
      // this.imageUrl = event.target.result;
     // this.imageUrl.push(event.target.result);
      this.imageUrl[i]=event.target.result;

      };
    } else {
      //this.alertService.showDangerAlert(this.errorDialog, imagevalidation);
    }
    this.imageAdd[i] = { 'ImageTitle': imagename, 'ImagePath': this.image };
    //console.log(this.imageAdd);
   // console.log(this.imageUrl);
  }

  showAddVideo() {
    this.videodisplay = "block";
    this.addVideoVisible = 1;
  }
  cancelAddVideo() {
    this.addVideoVisible = 0;
  }
  newChecklistItem() {
    this.checklistForm.controls.description.setValue('');
    this.display = "block";
    this.addChecklistItem = 1;
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.description = "";
    this.imageAdd = [];
    this.imageUrl=[];
    this.values = [];
  }
  cancelAddImage() {
    this.imagedisplay = "none";
    this.addImageInvisible = 0;
  }
  cancelAddChecklist() {
    this.display = "none";
    this.addChecklistItem = 0;
  }
  OnCancel() {
    this.display = "none";
    this.editdisplay = "none";
    this.addChecklistItem = 0;
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.description = "";
  }

  AddStep() {
    // let checkListObj: CheckListDTO;
    // checkListObj = new CheckListDTO();

    // checkListObj.StepNo = this.checkListIndex;
    // checkListObj.Description = this.description;
    // this.checkList.push(checkListObj);
    this.submitted = true;
    if (this.checklistForm.invalid)
      return;

    var formData: any = new FormData();
    let checklistTypeId: any = this.category;
    let userProcedureId: any = this.procedureId;

    formData.append('CheckListTypeID', checklistTypeId);
    formData.append('UserProcedureID', userProcedureId);
    formData.append('Description', this.checklistForm.controls['description'].value);
    formData.append('UserProcedureCheckListID', '0');
    let imagelistLength = this.imageAdd.length;
    for (var i = 1; i <= imagelistLength; i++) {
      formData.append("ImageTitle" + i, this.imageAdd[i - 1].ImageTitle);
      formData.append("ImageFile" + i, this.imageAdd[i - 1].ImagePath);
    }
    this.loading = true;
    this.scrubUpService.AddCheckList(this.token, formData).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'CheckList Saved Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

      } else {

      }
      //this.OnCancel();
      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });



  }

  closeModalDialog() {
    this.editdisplay = "none";
    this.display = "none";
    this.imagedisplay = "none";
    this.videodisplay = "none";
  }

  SaveCheckList() {
    // let userProcObJ: UserProcedureDataDTO;
    // userProcObJ = new UserProcedureDataDTO();
    // userProcObJ.SpecialityId = this.specialityId;
    // userProcObJ.ProcedureId = this.procedureId;
    // userProcObJ.UserId = this.loginUserId;
    // userProcObJ.Template = new TemplateDTO();
    // userProcObJ.Template.CheckList = this.checkList;
    // this.loading = true;
    // this.scrubUpService.AddCheckList(this.token, userProcObJ, this.category, this.appUserDetails.UserId).subscribe(x => {
    //   swal({
    //     title: 'CheckList Saved Successfully',
    //     type: "success",
    //     timer: 2000,
    //     showConfirmButton: false
    //   }).catch(swal.noop);

    //   this.OnCancel();
    //   this.loading = false;
    // });
  }

  UpdateChecklist() {
    this.submitted = true;
    if (this.checklistForm.invalid)
      return;

    //console.log(this.imageAdd);
    let imagelistLength = this.imageAdd.length;
    //console.log(imagelistLength);
    //  this.OnCancel();
    var formData: any = new FormData();
    let checklistTypeId: any = this.category;
    let userProcedureId: any = this.procedureId;
    //console.log(this.description);
    formData.append('CheckListTypeID', checklistTypeId);
    formData.append('UserProcedureID', userProcedureId);
    // formData.append('Description', this.description);
    formData.append('Description', this.checklistForm.controls['description'].value);
    formData.append('UserProcedureCheckListID', this.UserProcedureCheckListID);

    // let imagelistLength = this.imageAdd.length;
    for (var i = 1; i <= imagelistLength; i++) {
      //formData.append("UserProcedureCheckListImageID"+i,)
      formData.append("ImageTitle" + i, this.imageAdd[i - 1].ImageTitle);
      formData.append("ImageFile" + i, this.imageAdd[i - 1].ImagePath);
    }
    this.loading = true;
    this.scrubUpService.updateCheckList(this.token, formData).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'CheckList Updated Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      } else {

      }
      //this.OnCancel();
      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });

    this.imageUrl=[];

  }


  editChecklistItem(index: number, stepContent: any, UserProcedureCheckListID: any) {
    this.imageUrl=[];
    this.imageAdd=[];
    // this.values=images;
    // console.log(JSON.stringify(images));
    this.checklistForm.controls.description.setValue('');
    this.description = "";
    this.index1 = index;
    this.editmode = true;
    this.display = "block";
    this.editdisplay = "block";
    this.addChecklistItem = 1;
    this.addChecklistItem = 0;
    this.editvisi = 1;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      // this.description = stepContent;
      this.checklistForm.controls.description.setValue(stepContent);
      this.edit = false;
    }
    else {
      this.checklistForm.controls.description.setValue(stepContent);
      // this.description = stepContent;
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }

    //UserProcedureCheckListID= '2653';
    this.UserProcedureCheckListID = UserProcedureCheckListID;
    this.scrubUpService.editGetuserProcedurechecklist(this.token, UserProcedureCheckListID).subscribe(x => {
      if (x['Data'] != null && x.Status == true) {
        this.values = x['Data'];
        //this.imageAdd =x['Data'];
        let lengthimage = x['Data'].length;
        for (var i = 0; i < lengthimage; i++) {
          this.imageUrl[i]=x['Data'][i].ImagePath;
          this.imageAdd.push({ 'ImageTitle': x['Data'][i].ImageTitle, 'ImagePath': x['Data'][i].ImagePath });
        }

      }
      this.loading = false;
    });
  //console.log( this.imageUrl);

  }

  DeleteImage(SurgeonProcedureCheckListID,UserProcedureCheckListImageID) {
    let SurgeonId = this.cookieService.get("surgonId");
    let deleteImage = {
      "SurgeonId":SurgeonId,
      "SurgeonProcedureCheckListID": SurgeonProcedureCheckListID,
      "SurgeonProcedureCheckListImageID": UserProcedureCheckListImageID
    }

    this.scrubUpService.DeleteUserImages(this.token, deleteImage).subscribe(x => {
      if (x.Status == true) {
        this.GetComponentDetails();
        swal({
          title: 'Images deleted Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      } else if (x.Status == false) {
        swal({
          title: 'Deletion Failed!!',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }

    });
    //this.imageList.splice(index, 1);
  }

  DeleteCheckList(UserProcedureID) {

    // let checkListObj: DeleteCheckListDTO;
    // checkListObj = new DeleteCheckListDTO();
    // checkListObj.SpecialityId = this.specialityId;
    // checkListObj.ProcedureId = this.procedureId;
    // checkListObj.CheckList = this.checkList[index];

    swal({
      title: 'Are you sure you want to Delete this Checklist?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      let deletechecklist = {
        "UserProcedureCheckListID": UserProcedureID,
        "UserProcedureCheckListImageID": 0
      }

      this.scrubUpService.DeleteCheckList(this.token, deletechecklist).subscribe(x => {
        if (x.Status == true) {
          swal({
            title: 'CheckList deleted Successfully',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        } else if (x.Status == false) {
          swal({
            title: 'Deletion Failed!!',
            type: "info",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        }
        this.GetComponentDetails();
        this.OnCancel();
      });
      this.loading = false;
    });

  }


  AddVideo() {
    let videoObj: VideoDTO;
    videoObj = new VideoDTO();
    videoObj.VideoUrl = this.videoUrl;
    videoObj.Name = this.videoName;
    this.videoList.push(videoObj);
    let safeVideoObj: SafeVideoDTO;
    safeVideoObj = new SafeVideoDTO();
    safeVideoObj.SafeVideoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
    safeVideoObj.Name = this.videoName;
    this.safeVideoList.push(safeVideoObj);
    this.videoUrl = "";
    this.videoName = "";
    this.SaveVideoList();
  }
  SaveVideoList() {
    let userProcObJ: UserProcedureDataDTO;
    userProcObJ = new UserProcedureDataDTO();
    userProcObJ.SpecialityId = this.specialityId;
    userProcObJ.ProcedureId = this.procedureId;
    userProcObJ.UserId = this.loginUserId;
    userProcObJ.Template = new TemplateDTO();
    userProcObJ.Template.Videos = this.videoList;
    this.scrubUpService.AddVideos(this.token, userProcObJ, this.category, this.appUserDetails.UserId).subscribe(x => {
      swal({
        title: 'Videos Saved Successfully',
        type: "success",
        timer: 2000,
        showConfirmButton: false
      }).catch(swal.noop);
      this.cancelAddVideo();
    });

  }






  GetComponentDetails() {
   let checklistType= this.cookieService.get("checklistType");
   let SurgeonProcedureID = this.cookieService.get("SurgeonProcedureID");
  //this.surgonName=this.cookieService.get("surgonName");
    let SurgeonId = this.cookieService.get("surgonId");
    let packageTypesFeatures = JSON.parse(
      this.cookieService.get("PackageTypesFeatures")
    );

    const isPackageDowngraded = packageTypesFeatures.IsPackageDowngraded
      ? packageTypesFeatures.IsPackageDowngraded
      : false;

    const step = JSON.parse(localStorage.getItem("Step"));
    const stepFeatureValue = (step && step.FeatureValue) ? step.FeatureValue : 0;

   let postmanArray = {
    "CheckListTypeID": checklistType,
    "SurgeonProcedureID":SurgeonProcedureID,
    "SurgeonId": SurgeonId,
    "FeatureValue": stepFeatureValue,
    "IsPackageDowngraded": isPackageDowngraded
   }
    this.loading = true;
    this.imageList1 = [];
    this.tempUrl = [];
    this.scrubUpService.getSurgonProcedurechecklist(this.token, postmanArray).subscribe(x => {
 //console.log(x);
      if (x['Data'] != null && x.Status == true) {
        this.checkList = x['Data'];
        let checklistLength = x['Data'].length;
        for (var i = 0; i < checklistLength; i++) {

          let imageListlength = 0;
          imageListlength = x['Data'][i]['CheckListsImages'].length;
          for (var j = 0; j < imageListlength; j++) {
            // console.log(this.checkList[i]['CheckListsImages'][j]);
            this.tempUrl.push(this.checkList[i]['CheckListsImages'][j]);
          }
        }
        this.imageList1 = this.tempUrl;
        //console.log(this.imageList1);
      }
      this.loading = false;
    });


    this.scrubUpService.GetSurgeonPatientPositionings(this.token, SurgeonProcedureID).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.patientPosPressList = x['Data'];
      //console.log(this.patientPosPressList);
      }
     //console.log(this.patientPosPressList.length);
      this.loading = false;
    });



  }

  GoBack() {

    let compNmae: string;
    compNmae = this.route.routeConfig.component.name;

    // if (this.loginUserId == 1)

    this.router.navigateByUrl('layout', { skipLocationChange: true }).then(() =>
      this.router.navigate(["layout/procedure"]));
    //console.log(compNmae);

    // if (this.loginUserId != 1 && this.route.routeConfig.component.name == "UserProcedureComponent")
    //   this.router.navigateByUrl('layout', { skipLocationChange: true }).then(() =>
    //     this.router.navigate(["/layout/user-procedure"]));
    // if (this.loginUserId != 1 && this.route.routeConfig.component.name == "SurgeonlistComponent")
    //   this.router.navigateByUrl('layout', { skipLocationChange: true }).then(() =>
    //     this.router.navigate(["/layout/surgeonlist"]));
  }

  UserClick(btnCount) {

    this.index = false;
    this.edit = false;
    if (btnCount == 0) {

      this.index = true;
      this.edit = false;
    }
    if (btnCount == 1) {
      this.index = true;
      this.edit = false;
      this.selectedProcedureId = 0;

    }
    if (btnCount == 2) {
      this.edit = true;
      this.index = false;
    }
    if (btnCount == 3) {
      this.imagedisplay = "block";
      if (this.imageList.length == 5) {
        swal({
          title: 'Images limit reached ',

          showConfirmButton: true
        }).catch(swal.noop);
      }
      else {
        this.edit = true;
        this.addImageInvisible = 1;
      }
    }

  }
  checklistFormvalidation() {
    this.checklistForm = this.formBuilder.group({
      description: ['', Validators.required]
    });
  }
  get f() { return this.checklistForm.controls; }
  ngOnInit() {
    this.checklistFormvalidation();
    // Wizard Initialization
    $('.wizard-card').bootstrapWizard({
      // 'tabClass': 'nav nav-pills',
      // 'nextSelector': '.btn-next',
      // 'previousSelector': '.btn-previous',

      // onNext: (tab, navigation, index) => {


      //   return true;
      // },

      // onInit: function (tab: any, navigation: any, index: any) {

      //   // check number of tabs and fill the entire row
      //   let $total = navigation.find('li').length;
      //   let $wizard = navigation.closest('.wizard-card');

      //   let $first_li = navigation.find('li:first-child a').html();
      //   let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
      //   $('.wizard-card .wizard-navigation').append($moving_div);

      //   $total = $wizard.find('.nav li').length;
      //   let $li_width = 100 / $total;

      //   let total_steps = $wizard.find('.nav li').length;
      //   let move_distance = $wizard.width() / total_steps;
      //   let index_temp = index;
      //   let vertical_level = 0;

      //   let mobile_device = $(document).width() < 600 && $total > 3;

      //   if (mobile_device) {
      //     move_distance = $wizard.width() / 2;
      //     index_temp = index % 2;
      //     $li_width = 50;
      //   }

      //   $wizard.find('.nav li').css('width', $li_width + '%');

      //   let step_width = move_distance;
      //   move_distance = move_distance * index_temp;

      //   let $current = index + 1;

      //   if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
      //     move_distance -= 8;
      //   } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
      //     move_distance += 8;
      //   }

      //   if (mobile_device) {
      //     let x: any = index / 2;
      //     vertical_level = parseInt(x);
      //     vertical_level = vertical_level * 38;
      //   }

      //   $wizard.find('.moving-tab').css('width', step_width);
      //   $('.moving-tab').css({
      //     'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
      //     'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      //   });
      //   $('.moving-tab').css('transition', 'transform 0s');
      // },

      // onTabClick: (tab: any, navigation: any, index: any) => {


      //   return true;
      // },

      // onTabShow: (tab: any, navigation: any, index: any) => {
      //   let $total = navigation.find('li').length;
      //   let $current = index + 1;
      //   const $wizard = navigation.closest('.wizard-card');


      //   if ($current >= $total) {
      //     $($wizard).find('.btn-next').hide();
      //     $($wizard).find('.btn-finish').show();
      //   }
      //   else {
      //     $($wizard).find('.btn-next').show();
      //     $($wizard).find('.btn-finish').hide();
      //   }

      //   const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

      //   let $moving_div_image = "";
      //   if ($current == 1) {
      //     $moving_div_image = $('<i class="material-icons" style="vertical-align:bottom;padding-left:5px;">' + 'playlist_add_check' + '</i>');
      //   }
      //   else if ($current == 2) {
      //     $moving_div_image = $('<i class="material-icons" style="vertical-align:bottom;padding-left:5px;">' + 'image' + '</i>');
      //   }
      //   else if ($current == 3) {
      //     $moving_div_image = $('<i class="material-icons" style="vertical-align:bottom;padding-left:5px;">' + 'video_library' + '</i>');
      //   }

      //   setTimeout(function () {
      //     $('.moving-tab').text(button_text).append($moving_div_image);
      //   }, 150);

      //   const checkbox = $('.footer-checkbox');

      //   if (index !== 0) {
      //     $(checkbox).css({
      //       'opacity': '0',
      //       'visibility': 'hidden',
      //       'position': 'absolute'
      //     });
      //   } else {
      //     $(checkbox).css({
      //       'opacity': '1',
      //       'visibility': 'visible'
      //     });
      //   }
      //   $total = $wizard.find('.nav li').length;
      //   let $li_width = 100 / $total;

      //   let total_steps = $wizard.find('.nav li').length;
      //   let move_distance = $wizard.width() / total_steps;
      //   let index_temp = index;
      //   let vertical_level = 0;

      //   let mobile_device = $(document).width() < 600 && $total > 3;

      //   if (mobile_device) {
      //     move_distance = $wizard.width() / 2;
      //     index_temp = index % 2;
      //     $li_width = 50;
      //   }

      //   $wizard.find('.nav li').css('width', $li_width + '%');

      //   let step_width = move_distance;
      //   move_distance = move_distance * index_temp;

      //   $current = index + 1;

      //   if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
      //     move_distance -= 8;
      //   } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
      //     move_distance += 8;
      //   }

      //   if (mobile_device) {
      //     let x: any = index / 2;
      //     vertical_level = parseInt(x);
      //     vertical_level = vertical_level * 38;
      //   }

      //   $wizard.find('.moving-tab').css('width', step_width);
      //   $('.moving-tab').css({
      //     'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
      //     'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      //   });
      // }
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader: any = new FileReader();

        reader.onload = function (e: FileReaderEvent) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    this.GetComponentDetails();

  }

  ngOnChanges(changes: SimpleChanges) {
    const input = $(this);

    if (input[0].files && input[0].files[0]) {
      const reader: any = new FileReader();

      reader.onload = function (e: FileReaderEvent) {
        $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
      };
      reader.readAsDataURL(input[0].files[0]);
    }
  }
  onclick()
  {
    $('.moving-tab').css({
      "width" : "373.333px" ,
      "transform" : "translate3d(754.667px, 0px, 0px)",
      "transition" : "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s"
      });
      $('.moving-tab').html('Positioning and Pressure Points <img src="assets/img/ic_gynaecology.png" style="height:24px;width:24px;vertical-align:bottom;padding-left:5px;">');
  }
  ngAfterViewInit() {
    $('.wizard-card').each(function () {

      const $wizard = $(this);
      const index = $wizard.bootstrapWizard('currentIndex');
      let $total = $wizard.find('.nav li').length;
      let $li_width = 100 / $total;

      let total_steps = $wizard.find('.nav li').length;
      let move_distance = $wizard.width() / total_steps;
      let index_temp = index;
      let vertical_level = 0;

      let mobile_device = $(document).width() < 600 && $total > 3;

      if (mobile_device) {
        move_distance = $wizard.width() / 2;
        index_temp = index % 2;
        $li_width = 50;
      }

      $wizard.find('.nav li').css('width', $li_width + '%');

      let step_width = move_distance;
      move_distance = move_distance * index_temp;

      let $current = index + 1;

      if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
        move_distance -= 8;
      } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
        move_distance += 8;
      }

      if (mobile_device) {
        let x: any = index / 2;
        vertical_level = parseInt(x);
        vertical_level = vertical_level * 38;
      }

      $wizard.find('.moving-tab').css('width', step_width);
      $('.moving-tab').css({
        'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
        'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      });

      $('.moving-tab').css({
        'transition': 'transform 0s'
      });
    });
  }


}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/procedure-user-comp/procedure-user-comp.component.ts